import React, {FC, useEffect, useState} from "react"
import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import {SelectionListOption} from "@irati-internal/app/src/components/RegionForm/RegionForm"
import tagService from "@irati/tag/services/tag"
import {Region, Tag, TagKind} from "@irati/types"

interface Props {
  region: Partial<Region>,
  onChange: (fieldName: string, value: any) => void
}

const RegionHomepageCategory: FC<Props> = ({region, onChange}) => {
  const [homepageCategorySelectionList, setHomepageCategorySelectionList] = useState<SelectionListOption[]>([])

  useEffect(() => {
    getHomepageTagsSelectionList().then((data) => setHomepageCategorySelectionList(data))
  }, [])

  const getHomepageTagsSelectionList = async() => {
    const tagsResult = await tagService.list({kind: TagKind.DealCategories})
    return tagsResult.map((tag: Tag) => {
      const {name, uuid} = tag
      return {value: uuid, label: name}
    })
  }

  return (
    <Select
      name="type"
      label="Categories"
      hint={
        <>
          This is the "Categories" list seen on the screen seen at{" "}
          <a href="https://home.perkbox.com/perks/categories">https://home.perkbox.com/perks/categories</a>
        </>
      }
      value={region.homepageCategoryId}
      isClearable={false}
      options={homepageCategorySelectionList}
      onChange={(newValue) => onChange("homepageCategoryId", newValue)}
      validation={Validation.string("Please select a homepage category.")} />
  )
}

export default RegionHomepageCategory
